/**
 * Converts a string to title case, handling special cases like hyphenated words
 * Example: "CO-OWNER" -> "Co-Owner"
 * @param str The string to convert
 * @returns The string in title case
 */
export function titleCase(str: string): string {
  // Handle empty or null strings
  if (!str) return str;

  // Split on hyphens to handle hyphenated words
  return str.split('-').map(word => 
    // For each part, split into words and capitalize
    word.toLowerCase().split(' ').map(part => 
      part.charAt(0).toUpperCase() + part.slice(1)
    ).join(' ')
  ).join('-');
}

/**
 * Formats a phone number for display
 * Example: "14152548484" -> "+1 (415) 254-8484"
 * @param phone The phone number string to format
 * @returns The formatted phone number or original string if not a standard US format
 */
export function formatPhoneNumber(phone: string): string {
  if (!phone) return phone;
  
  // Remove all non-digits
  const digits = phone.replace(/\D/g, '');
  
  // Format as (XXX) XXX-XXXX for US numbers
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  } else if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  
  return phone; // Return original if not a standard US format
}

/**
 * Player headshot URLs from RW/MLB are often `http://`; HTTPS apps block mixed content.
 * Use for Avatar/img `src` from `rwPlayer.image` (and similar).
 */
export function httpsPlayerImageUrl(url: string | null | undefined): string | undefined {
  if (url == null || typeof url !== 'string') return undefined;
  const trimmed = url.trim();
  if (!trimmed) return undefined;
  if (trimmed.startsWith('http://')) {
    return `https://${trimmed.slice('http://'.length)}`;
  }
  return trimmed;
}